export default __webpack_public_path__ + "static/pielonefral-cb608b19756fe61a97cf62b25a8c9655.jpg";